import { Button, Center, Flex, Modal, Text } from "@mantine/core";
import { ReactNode } from "react";
import { LanguageSelect } from "../../components";
import { useTranslation } from "react-i18next";

type IProps = {
  setCancelRegister: () => void;
  title: ReactNode;
  isLoading: boolean;
};

const HeaderModal = ({ setCancelRegister, title, isLoading }: IProps) => {
  const { t } = useTranslation();
  return (
    <Modal.Header
      p="0"
      style={{
        gap: "24px",
        alignItems: "center",
        justifyContent: "start",
        boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
        background: "white",
      }}
    >
      <Center w="100%">
        <Flex
          justify="space-between"
          align={"center"}
          maw={1920}
          p={{ base: "24px 120px", 991: "28px 48px", 1600: "28px 120px" }}
          w="100%"
        >
          <Text fw={600} c="basic.5" fz={24} lh="32px">
            {title}
          </Text>
          <Flex gap={24}>
            <LanguageSelect />
            <Button
              fullWidth
              maw={"fit-content"}
              variant="dangerOutline"
              onClick={() => setCancelRegister()}
              disabled={isLoading}
            >
              {t("marketplace.comprar_agora.button_back")}
            </Button>
          </Flex>
        </Flex>
      </Center>
    </Modal.Header>
  );
};

export default HeaderModal;
